import React, { ReactNode } from 'react'
import classnames from 'classnames'

const ListToolbar = ({ children, className }: { children: ReactNode, className?: string }) => {
  return <div className={classnames('z-20 flex w-full p-2.5 text-sm bg-white shadow-sm', className)}>{children}</div>
}

export default ListToolbar
